export const rssListEN = [
	{
		title: 'Link to product',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Product page',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Technical data sheet',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Technical data sheet',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Installation Manual',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Installation Manual',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Video',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Video',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]

export const rssListFR = [
	{
		title: 'Lien vers le produit',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Page produit',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Fiche technique',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Fiche technique',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Notice de montage',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Notice de montage',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Vidéo',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Vidéo',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]

export const rssListPL = [
	{
		title: 'Link do produktu',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Link do produktu',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Karta katalogowa',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Karta katalogowa',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Instrukcja montażu',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Instrukcja montażu',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Film',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Film',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]



export const rssListPT = [
	{
		title: 'Link para o produto',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Link para o produto',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Ficha técnica',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Ficha técnica',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Manual de instalação',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Manual de instalação',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Video',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Video',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]

export const rssListES = [
	{
		title: 'Enlace hacia el producto',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Enlace hacia el producto',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Ficha técnica',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Ficha técnica',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Instrucciones de instalación',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Instrucciones de instalación',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Video',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Video',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]

export const rssListDE = [
	{
		title: 'Link zum Produkt',
		liId: 'li_produitLien',
		aId: 'produitLien',
		imgClass: 'produit_lien',
		tooltip: 'Link zum Produkt',
		pathNormal: 'Ressources/links/icon_productlink_blue.svg',
		pathHover: 'Ressources/links/icon_productlink.svg'
	},
	{
		title: 'Technisches Datenblatt',
		liId: 'li_ficheLien',
		aId: 'ficheLien',
		imgClass: 'fiche_lien',
		tooltip: 'Technisches Datenblatt',
		pathNormal: 'Ressources/links/icon_fiche_technique_blue.svg',
		pathHover: 'Ressources/links/icon_fiche_technique.svg'
	},
	{
		title: 'Montageanleitung',
		liId: 'li_montageLien',
		aId: 'montageLien',
		imgClass: 'montage_lien',
		tooltip: 'Montageanleitung',
		pathNormal: 'Ressources/links/icon_notice_montage_blue.svg',
		pathHover: 'Ressources/links/icon_notice_montage.svg'
	},
	{
		title: 'Video',
		liId: 'li_videoLien',
		aId: 'videoLien',
		imgClass: 'video_lien',
		tooltip: 'Video',
		pathNormal: 'Ressources/links/icon_video_blue.svg',
		pathHover: 'Ressources/links/icon_video.svg'
	}
]

export const referenceTrad = 
{
	fr: 'Référence',
	en: 'Reference',
	pl: 'Numer referencyjny',
	pt: 'Referência',
	es: 'Referencia',
	de: 'Referenz'
}